function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessCircleTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "success_circle_tick") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3812",
    style: {
      fill: "none"
    },
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.722-811.385 14.227-14.227-1.316-1.3-12.91 12.953-6.5-6.5-1.261 1.3zM140.007-800a19.309 19.309 0 0 1-7.766-1.574 20.378 20.378 0 0 1-6.36-4.3 20.356 20.356 0 0 1-4.305-6.354 19.269 19.269 0 0 1-1.576-7.765 19.492 19.492 0 0 1 1.574-7.8 19.979 19.979 0 0 1 4.3-6.354 20.6 20.6 0 0 1 6.354-4.277 19.269 19.269 0 0 1 7.765-1.576 19.493 19.493 0 0 1 7.8 1.574 20.211 20.211 0 0 1 6.354 4.273 20.19 20.19 0 0 1 4.277 6.348 19.453 19.453 0 0 1 1.576 7.8 19.309 19.309 0 0 1-1.574 7.766 20.619 20.619 0 0 1-4.273 6.36 19.957 19.957 0 0 1-6.348 4.305 19.452 19.452 0 0 1-7.798 1.574zm-.007-1.709a17.632 17.632 0 0 0 12.962-5.336A17.649 17.649 0 0 0 158.291-820a17.643 17.643 0 0 0-5.329-12.962A17.643 17.643 0 0 0 140-838.291a17.649 17.649 0 0 0-12.955 5.329A17.632 17.632 0 0 0 121.709-820a17.638 17.638 0 0 0 5.336 12.955A17.638 17.638 0 0 0 140-801.709zM140-820z",
    transform: "translate(-116 844)",
    style: {
      fill: "#479b5e"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCircleTick);
export default __webpack_public_path__ + "static/media/success_circle_tick.482c058d9f284342f45eb0f29ba93eba.svg";
export { ForwardRef as ReactComponent };